import React from "react";
import moment from "moment";
import "./InventoryTables.css";
import EditLogo from "../../Assets/editLogo.png";
import SearchLogo from "../../Assets/search-icon.png";
import {
  formatDot,
  switchDotsAndCommas,
  numberWithCommas,
} from "../../util/utilFunction";

const rupiah = (n) =>
  `Rp. ${formatDot(switchDotsAndCommas(numberWithCommas(n)))}`;

const Dash = () => <span className="tb-dash">–</span>;

// Sel dua baris: baris atas tebal, baris bawah abu-abu
const CodeCell = ({ code, sub }) =>
  code ? (
    <div className="tb-code">
      <b>{code}</b>
      {sub ? <span>{sub}</span> : null}
    </div>
  ) : (
    <Dash />
  );

const TableBarangJadi = ({ data, isPin, getKodeKirim, onEdit, onHistory }) => {
  const rows = Array.isArray(data) ? data : [];

  const showHarga = isPin === "1020";

  const totalNilai = rows.reduce((sum, e) => {
    if (e?.harga && e?.weight && e.weight > 0) {
      return sum + e.harga * e.weight;
    }
    return sum;
  }, 0);

  const colCount = 19 + (showHarga ? 2 : 0);

  return (
    <div className="tb-card">
      <div className="tb-summary">
        <span className="tb-chip">
          Total item <b>{rows.length}</b>
        </span>
        {showHarga ? (
          <span className="tb-chip tb-chip-accent">
            Total nilai <b>{rupiah(totalNilai)}</b>
          </span>
        ) : null}
      </div>

      <div className="tb-scroll tb-scroll-bj">
        <table className="tb-table tb-bj">
          <thead>
            <tr>
              <th className="tb-c1">No.</th>
              <th className="tb-c2">Nama Produk</th>
              {showHarga ? (
                <>
                  <th className="tb-num">Harga</th>
                  <th className="tb-num">Total</th>
                </>
              ) : null}
              <th className="tb-num">Jumlah (Pcs)</th>
              <th>Last Update</th>
              <th>Kode Barang & Kode Kirim</th>
              <th>Aksi</th>
              <th className="tb-gs">Tier</th>
              <th>Runner (gr)</th>
              <th>Berat (gr)</th>
              <th className="tb-gs">Level 1</th>
              <th>Level 2</th>
              <th>Level 3</th>
              <th className="tb-gs">BB</th>
              <th>Crusher</th>
              <th>Pewarna</th>
              <th>Maba (%)</th>
              <th className="tb-gs">Pendukung 1</th>
              <th>Pendukung 2</th>
              <th>Pendukung 3</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr className="tb-empty">
                <td colSpan={colCount}>Tidak ada data</td>
              </tr>
            ) : (
              rows.map((e, index) => {
                const weight = Number(e?.weight) || 0;
                const kk = (kode) =>
                  kode && getKodeKirim ? getKodeKirim(kode) : "";

                return (
                  <tr key={`${e?.kodeBarang || e?.material || "row"}-${index}`}>
                    <td className="tb-c1">{index + 1}.</td>
                    <td className="tb-c2">{e?.material}</td>

                    {showHarga ? (
                      <>
                        <td className="tb-num">
                          {e?.harga ? rupiah(e.harga) : <Dash />}
                        </td>
                        <td className="tb-num">
                          {e?.harga ? rupiah(e.harga * weight) : <Dash />}
                        </td>
                      </>
                    ) : null}

                    <td className={weight < 0 ? "tb-num tb-neg" : "tb-num"}>
                      {weight < 0
                        ? `(${formatDot(Math.round(weight))})`
                        : formatDot(Math.round(weight))}
                    </td>

                    <td>
                      {e?.updateTime ? (
                        <div className="tb-code">
                          <b>{moment(e.updateTime).format("DD-MM-YYYY")}</b>
                          <span>{moment(e.updateTime).format("HH:mm:ss")}</span>
                        </div>
                      ) : (
                        <Dash />
                      )}
                    </td>

                    <td>
                      <CodeCell code={e?.kodeBarang} sub={e?.kodeKirim} />
                    </td>

                    <td>
                      <div className="tb-actions">
                        <button
                          type="button"
                          className="tb-icon-btn"
                          onClick={() => onEdit && onEdit(e)}
                          aria-label="Edit barang"
                          title="Edit"
                        >
                          <img src={EditLogo} alt="edit" />
                        </button>
                        <button
                          type="button"
                          className="tb-icon-btn"
                          onClick={() => onHistory && onHistory(e)}
                          aria-label="Lihat riwayat"
                          title="Riwayat"
                        >
                          <img src={SearchLogo} alt="search" />
                        </button>
                      </div>
                    </td>

                    <td className="tb-gs">
                      {e?.level ? (
                        <span className={`tb-badge tb-badge-${e.level}`}>
                          {e.level}
                        </span>
                      ) : (
                        <Dash />
                      )}
                    </td>
                    <td>{e?.runner || <Dash />}</td>
                    <td>{e?.berat || <Dash />}</td>

                    <td className="tb-gs">
                      <CodeCell code={e?.level1} sub={kk(e?.level1)} />
                    </td>
                    <td>
                      <CodeCell code={e?.level2} sub={kk(e?.level2)} />
                    </td>
                    <td>
                      <CodeCell code={e?.level3} sub={kk(e?.level3)} />
                    </td>

                    <td className="tb-gs">{e?.bahanBaku || <Dash />}</td>
                    <td>{e?.crusher || <Dash />}</td>
                    <td>{e?.pewarna || <Dash />}</td>
                    <td>
                      {e?.komposisiMaba ? <b>{e.komposisiMaba} %</b> : <Dash />}
                    </td>

                    <td className="tb-gs">
                      <CodeCell code={e?.pendukung1} sub={kk(e?.pendukung1)} />
                    </td>
                    <td>
                      <CodeCell code={e?.pendukung2} sub={kk(e?.pendukung2)} />
                    </td>
                    <td>
                      <CodeCell code={e?.pendukung3} sub={kk(e?.pendukung3)} />
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableBarangJadi;
